
import connect, { connectIntl, IMapStateToProps } from '../../../../Hooks/Context/connect';

import { AuthFunctionalContext, IAuthReducerContext } from '../Context/AuthFunctionalContext';
import { IAuthState } from '../Store/Reducers';
import { IUseCombinedReducersProps } from './useCombinedReducers';

type IAuthMapStateToProps<P> = IMapStateToProps<IAuthState, P>;

type IConnectedPropsNull = IUseCombinedReducersProps;
type IConnectedProps<P = null> = P & IConnectedPropsNull;

function connectAuth<P, A = null>(mapStateToProps?: IMapStateToProps<IAuthState, P>) {
    return (Component: any) => connect<IAuthReducerContext, IAuthState, P, A>(AuthFunctionalContext, mapStateToProps)(Component);
}
function connectIntlAuth<P, A = null>(mapStateToProps: IMapStateToProps<IAuthState, P>) {
    return (Component: any) => connectIntl<IAuthReducerContext, IAuthState, P, A>(AuthFunctionalContext, mapStateToProps)(Component);
}

export {
    connectIntlAuth,

    IConnectedProps,
    IConnectedPropsNull,
    IAuthMapStateToProps
};
export default connectAuth;
